import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, Form, FormItemProps } from 'antd';
import styles from './index.module.scss';
import PasswordLoginPriv, { IFormStore } from 'lib/publicUsecase/PasswordLoginPriv';
import { noop } from 'lodash';
import { appMessageError, appMessageSuccess } from 'model/app';
import LoginGraphicCapatchaItem from 'component/AuthForm/LoginGraphicCapatchaItem';
import LoginPasswordItem from 'component/AuthForm/LoginPasswordItem';
interface IProps {
  onSuccess: () => void;
}

const ModifyPasswordComponent: React.FC<IProps> = ({ onSuccess }) => {
  const [form] = Form.useForm<IFormStore>();
  const dispatch = useDispatch();

  const passwordLogin = new PasswordLoginPriv();

  const stateData = passwordLogin.stateStore.value;
  const formData = passwordLogin.formStore.value;

  function onFieldsChange() {
    const newData = form.getFieldsValue();
    passwordLogin.formStore.set(newData);
  }

  async function handleSumbit() {
    const formRes = await form.validateFields().catch(noop);
    if (!formRes) return;

    const data = await passwordLogin.fetchPasswordReset();
    if (data) {
      // 设置密码成功
      dispatch(appMessageSuccess('设置密码成功'));
      // 私有化不更新 token
      onSuccess && onSuccess();
    } else {
      dispatch(appMessageError('设置密码失败，请稍后再试'));
    }
  }

  const oldPasswordRules: FormItemProps['rules'] = [
    {
      required: true,
      message: '请输入原密码'
    }
  ];

  const NewPasswordRules: FormItemProps['rules'] = [
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value) {
          return Promise.reject(new Error('请输入新密码'));
        }
        if (getFieldValue('password') === value) {
          return Promise.reject(new Error('新密码不能与原密码相同'));
        }
        return Promise.resolve();
      }
    })
  ];

  const ConfirmPasswordRules: FormItemProps['rules'] = [
    ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value) {
          return Promise.reject(new Error('请输入确认密码'));
        }
        if (getFieldValue('newPassword') === value) {
          return Promise.resolve();
        }
        return Promise.reject(new Error('两次输入的密码不一致'));
      }
    })
  ];

  const handleCancel = () => {
    onSuccess && onSuccess();
  };

  const { password, newPassword, confirmPassword, graphicCaptcha } = form.getFieldsValue();
  const btnEnable = password && newPassword && confirmPassword && (!stateData.graphicCaptchaUrl || graphicCaptcha);

  // eslint-disable-next-line multiline-ternary
  return (
    <div className={styles.formWrapper}>
      {/* <LoginLoading status={loginStatus} /> */}
      <Form form={form} onFieldsChange={onFieldsChange} initialValues={formData}>
        <LoginPasswordItem name="password" help={stateData.passwordError} rules={oldPasswordRules} placeholder="原密码" />
        <LoginGraphicCapatchaItem
          src={stateData.graphicCaptchaUrl}
          name="graphicCaptcha"
          help={stateData.graphicCaptchaError}
          onReset={passwordLogin.refrashGraphicCaptchaUrl}
        />
        <LoginPasswordItem name="newPassword" help={stateData.newPasswordError} rules={NewPasswordRules} placeholder="新密码" />
        <LoginPasswordItem type="confirm" name="confirmPassword" rules={ConfirmPasswordRules} placeholder="确认密码" />
        <div className={styles.buttonWrapper}>
          <Button className={styles.buttonCancel} disabled={stateData.btnLoading} onClick={handleCancel}>
            取消
          </Button>
          <Button className={styles.buttonSubmit} loading={stateData.btnLoading} disabled={!btnEnable} type="primary" htmlType="submit" onClick={handleSumbit}>
            确定
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default ModifyPasswordComponent;
